import { updateMerchantPaymentSettings } from "@api";
import { useMerchant, usePaymentSettings } from "@auth";

const emptyConfig = {
  allowAmex: false,
  allowKlarna: false,
  allowCard: false,
  allowOpenBanking: false,
};

export default function usePaymentSettingsForm() {
  const { merchant } = useMerchant();
  const { paymentSettings: rawPaymentSettings, reloadPaymentSettings } =
    usePaymentSettings();

  const paymentSettings = rawPaymentSettings ?? {};

  const {
    paymentRequests = emptyConfig,
    checkout = emptyConfig,
    corporateCardSurchargePercent = null,
    klarnaAccountEmail = "",
    passOnCorporateCardFee = false,
    checkoutPassOnCorporateCardFee = false,
    terminals = null,
  } = paymentSettings;

  const submitPaymentSettings = async (values) => {
    await updateMerchantPaymentSettings({
      paymentRequests: values.paymentRequests,
      checkout: values.checkout,
      corporateCardSurchargePercent: values.corporateCardSurchargePercent,
      klarnaAccountEmail: values.klarnaAccountEmail,
      passOnCorporateCardFee: values.passOnCorporateCardFee,
      checkoutPassOnCorporateCardFee: values.checkoutPassOnCorporateCardFee,
      // Pages that don't manage terminal settings round-trip the current values
      // so the payment-settings payload stays complete.
      terminals: values.terminals ?? terminals,
    });
    await reloadPaymentSettings();
  };

  return {
    merchant,
    paymentSettings,
    paymentRequests,
    checkout,
    corporateCardSurchargePercent,
    klarnaAccountEmail,
    passOnCorporateCardFee,
    checkoutPassOnCorporateCardFee,
    terminals,
    submitPaymentSettings,
  };
}
